<template>
    <b-field :label="label" label-position="inside" :message="message" :type="message ? 'is-warning' : ''">
        <div v-if="selected" class="entity-select-chosen">
            <div class="entity-select-info">
                <div class="entity-select-name"><i class="far fa-tennis-ball mr-2"></i>{{selected.title}}</div>
                <div class="entity-select-meta" v-if="selected.start_on">{{selected.start_on | moment('MMM Do, YYYY')}} - {{selected.end_on | moment('MMM Do, YYYY')}}</div>
            </div>
            <b-button size="is-small" outlined @click="clear"><i class="fal fa-times mr-2"></i>Change</b-button>
        </div>
        <b-autocomplete
            v-else
            v-model="query"
            :data="filteredTrips"
            :loading="loading"
            field="title"
            open-on-focus
            @select="select"
            icon="search"
            :placeholder="placeholder">
            <template slot-scope="props">
                <div>
                    <strong>{{props.option.title}}</strong>
                    <br>
                    <small v-if="props.option.start_on">{{props.option.start_on | moment('MMM Do, YYYY')}} - {{props.option.end_on | moment('MMM Do, YYYY')}}</small>
                </div>
            </template>
            <template slot="empty">No trips found.</template>
        </b-autocomplete>
    </b-field>
</template>

<script>
    import {client as http} from '../http_client';

    export default {
        name: 'TripSelect',
        props: {
            value: {
                type: [Number, String],
                default: null
            },
            label: {
                type: String,
                default: 'Trip'
            },
            placeholder: {
                type: String,
                default: 'Search trips...'
            },
            message: {
                type: String,
                default: ''
            }
        },
        data: function () {
            return {
                selected: null,
                query: '',
                trips: [],
                loading: false
            };
        },
        computed: {
            filteredTrips() {
                if (!this.query || !this.query.length) return this.trips;
                const q = this.query.toLowerCase();
                return this.trips.filter(t => t.title && t.title.toLowerCase().indexOf(q) >= 0);
            }
        },
        methods: {
            loadTrips() {
                this.loading = true;
                Promise.all([
                    http.get('/api/trips/active/0/500'),
                    http.get('/api/trips/archived/0/500')
                ]).then(([active, archived]) => {
                    this.trips = [...active.data.trips, ...archived.data.trips];
                }).finally(() => {
                    this.loading = false;
                });
            },
            select(option) {
                if (!option) return;
                this.selected = option;
                this.$emit('input', option.id);
            },
            clear() {
                this.selected = null;
                this.query = '';
                this.$emit('input', null);
            },
            loadSelected(id) {
                if (!id) {
                    this.selected = null;
                    return;
                }
                http.get(`/api/trips/${id}`).then(response => {
                    this.selected = response.data;
                });
            }
        },
        watch: {
            value(newVal) {
                if (this.selected && this.selected.id == newVal) return;
                this.loadSelected(newVal);
            }
        },
        mounted() {
            this.loadTrips();
            this.loadSelected(this.value);
        }
    };
</script>

<style lang="scss" scoped>
    .entity-select-chosen {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 0.5rem;
        border: 1px solid #dbdbdb;
        border-radius: 4px;
        padding: 1.65em 0.75rem 0.5rem;

        .entity-select-info {
            min-width: 0;
        }

        .entity-select-name {
            font-weight: 700;
        }

        .entity-select-meta {
            font-size: .8rem;
            color: #7a7a7a;
        }
    }

    ::v-deep .autocomplete {
        .dropdown-menu {
            width: max-content;
            min-width: 100%;
            max-width: 340px;
        }

        .dropdown-item {
            white-space: normal;
            overflow: visible;
            text-overflow: initial;
        }
    }
</style>
